module.exports = __webpack_public_path__ + "img/partner-new-icon8.264f2a77.svg";